// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("grid"),
      BsCssJs$PrezzeeRibbon.gridTemplateColumns([BsCssJs$PrezzeeRibbon.fr(1)]),
      BsCssJs$PrezzeeRibbon.gridTemplateRows(["auto"]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
            BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 2
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }]),
            BsCssJs$PrezzeeRibbon.gridColumnGap(BsCssJs$PrezzeeRibbon.pct(2))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.gridColumnGap(BsCssJs$PrezzeeRibbon.pct(1))]),
      BsCssJs$PrezzeeRibbon.selector("a", [BsCssJs$PrezzeeRibbon.textDecoration("none")])
    ]);

var threePerRow = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 3
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }])])]);

var fourPerRow = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 4
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }])])]);

var fivePerRow = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 5
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }])])]);

var Styles = {
  container: container,
  threePerRow: threePerRow,
  fourPerRow: fourPerRow,
  fivePerRow: fivePerRow
};

function TeamMembersBlock(props) {
  var perRow = props.perRow;
  var perRow$1 = perRow !== undefined ? perRow : /* Four */1;
  var perRowClass;
  switch (perRow$1) {
    case /* Three */0 :
        perRowClass = threePerRow;
        break;
    case /* Four */1 :
        perRowClass = fourPerRow;
        break;
    case /* Five */2 :
        perRowClass = fivePerRow;
        break;
    
  }
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    container,
                    perRowClass
                  ])
            });
}

var make = TeamMembersBlock;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
